// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ConfirmationModal-cls1___9a5b619119e408fc52f{/*!*/}.ConfirmationModal-cls2__c0848c6fbff620bb2d4c{font-size:16px;line-height:20px}@media(min-width: 768px){.ConfirmationModal-cls2__c0848c6fbff620bb2d4c{font-size:22px;line-height:28px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ConfirmationModal-cls1___9a5b619119e408fc52f",
	"cls2": "ConfirmationModal-cls2__c0848c6fbff620bb2d4c ConfirmationModal-cls1___9a5b619119e408fc52f"
};
export default ___CSS_LOADER_EXPORT___;
